var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovieicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391",
    transform: "translate(-773.238 -3025.643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(773.238 3025.643)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(787.842 3038.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4748",
    "data-name": "Path 4748",
    d: "M-380.019,203.3V187.976h-1.894v1.863h-20.51v-1.868h-1.863v15.316h1.9v-5.066h20.51V203.3Zm-11.092,8.271c.671.4,1.282.742,1.876,1.116a.477.477,0,0,0,.573-.006c2.1-1.212,4.235-2.367,6.3-3.636a5.106,5.106,0,0,1,3.485-.921.26.26,0,0,0,.04,0,1.587,1.587,0,0,0,1.541-2,1.562,1.562,0,0,0-1.729-1.217H-396.6c-2.962,0-5.924-.005-8.885.006a1.518,1.518,0,0,0-1.557,1.615,1.541,1.541,0,0,0,1.583,1.6c.467,0,.936-.028,1.4.011a2.236,2.236,0,0,1,.9.241q10.176,5.792,20.337,11.609c.729.416,1.452.842,2.187,1.248a1.049,1.049,0,0,0,1.292-.146,1,1,0,0,0,.2-1.243,2.045,2.045,0,0,0-.675-.594q-9.48-5.441-18.97-10.865c-.118-.068-.234-.139-.419-.25h13.98l.014.063Zm-2.038,3.648c-.7-.41-1.347-.8-2.008-1.167a.429.429,0,0,0-.353.031q-4.69,2.7-9.37,5.416a1.032,1.032,0,0,0-.4,1.449,1.06,1.06,0,0,0,1.489.371l9.774-5.595C-393.743,215.564-393.47,215.4-393.149,215.216Z",
    transform: "translate(407.039 -187.971)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4749",
    "data-name": "Path 4749",
    d: "M-348.383,203.3h-1.859v-5.076h-20.51v5.066h-1.9V187.971h1.863v1.868h20.51v-1.863h1.894Z",
    transform: "translate(375.404 -187.971)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4750",
    "data-name": "Path 4750",
    d: "M-391.11,406.067l5.895-3.373-.014-.064h-13.98c.185.111.3.183.419.25q9.487,5.43,18.97,10.865a2.045,2.045,0,0,1,.675.594,1,1,0,0,1-.2,1.243,1.049,1.049,0,0,1-1.292.146c-.735-.405-1.458-.831-2.187-1.248q-10.166-5.809-20.337-11.609a2.236,2.236,0,0,0-.9-.241c-.464-.04-.933-.007-1.4-.011a1.541,1.541,0,0,1-1.583-1.6,1.518,1.518,0,0,1,1.557-1.615c2.962-.011,5.924-.006,8.885-.006h17.57a1.562,1.562,0,0,1,1.729,1.217,1.587,1.587,0,0,1-1.541,2,.254.254,0,0,1-.04,0,5.106,5.106,0,0,0-3.485.921c-2.064,1.27-4.2,2.424-6.3,3.636a.477.477,0,0,1-.573.006C-389.829,406.809-390.44,406.463-391.11,406.067Z",
    transform: "translate(407.039 -382.47)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4751",
    "data-name": "Path 4751",
    d: "M-374.664,514.523c-.321.187-.594.348-.869.505l-9.774,5.6a1.06,1.06,0,0,1-1.489-.371,1.032,1.032,0,0,1,.4-1.449q4.68-2.716,9.37-5.416a.429.429,0,0,1,.353-.031C-376.012,513.723-375.363,514.113-374.664,514.523Z",
    transform: "translate(388.555 -487.277)",
    fill: "#febaba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieicon);
export default __webpack_public_path__ + "static/media/movieicon.8684a57ea15839f1c3778afe12140237.svg";
export { ForwardRef as ReactComponent };